import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Testimonials() {
  const { t } = useLanguage();
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">{t.testimonials.eyebrow}</div>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-white leading-[0.95] break-words">
            {t.testimonials.headingLine1}
            <br />
            <span className="text-gold">{t.testimonials.headingLine2}</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
          {t.testimonials.items.map((tst, i) => (
            <motion.div
              key={tst.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="relative bg-ink-card rounded-lg p-8 border border-ink-line hover:border-gold/40 transition-colors"
            >
              <Quote className="absolute top-6 right-6 text-gold/20" size={48} />
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} size={18} className="fill-gold text-gold" />
                ))}
              </div>
              <p className="text-white/90 text-base leading-relaxed relative z-10">"{tst.quote}"</p>
              <div className="mt-6 pt-6 border-t border-ink-line flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center font-heading text-gold text-lg">
                  {tst.initials}
                </div>
                <div>
                  <div className="font-bold text-white">{tst.name}</div>
                  <div className="text-white/60 text-xs">
                    {tst.role} · {tst.state}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
